import React, { useEffect, useState } from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";

import { NavLink, useLocation, useNavigate } from "react-router-dom";

import logo3 from "../Images/darklogo.png";
import logo2 from "../Images/darklogonn.png";
// import logo2 from "../Images/winners.png";

import { ArrowRight } from "lucide-react";
import HomeService from "../Services/HomeService";
import { toast } from "react-toastify";

export function WinnersFooterBlue() {
  const [email, setEmail] = useState("");
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const isDark = document.documentElement.classList.contains("dark");

  const [profileData, setProfileData] = useState({});
  const [isLoggedIn, setIsLoggedIn] = useState(false);


  /* =========================================================
     GET LOGGED-IN PROFILE
  ========================================================= */

  // useEffect(() => {
  //   getLoginProfile();
  // }, []);

  // const getLoginProfile = async () => {
  //   try {
  //     const res = await HomeService.getLoginProfile();

  //     if (res?.status) {
  //       setProfileData(res?.data || {});
  //     } else {
  //       setProfileData({});
  //     }
  //   } catch (error) {
  //     console.log("Footer profile error:", error);

  //     // User is not logged in
  //     setProfileData({});
  //   }
  // };

  useEffect(() => {
    let mounted = true;

    const checkLoginStatus = async () => {
      try {
        const res = await HomeService.getLoginProfile();

        if (!mounted) return;

        setIsLoggedIn(Boolean(res?.status && res?.data?._id));
      } catch (error) {
        if (mounted) {
          setIsLoggedIn(false);
        }
      }
    };

    checkLoginStatus();

    // Check again when user comes back to the page/tab
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkLoginStatus();
      }
    };

    // Check when browser storage changes
    const handleStorageChange = () => {
      checkLoginStatus();
    };

    document.addEventListener(
      "visibilitychange",
      handleVisibilityChange
    );

    window.addEventListener(
      "storage",
      handleStorageChange
    );

    return () => {
      mounted = false;

      document.removeEventListener(
        "visibilitychange",
        handleVisibilityChange
      );

      window.removeEventListener(
        "storage",
        handleStorageChange
      );
    };
  }, []);


  const HalfFooterLinks = [
    "/community-fav-list",
    "/list-of-favourites",
    "/deactive-properties",
    "/new-properties",
    "/active-properties",
    "/communitylist",
    "/propertylist",
  ];

  const handleNotify = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email || !emailRegex.test(email.trim())) {
      return toast.error("Please enter a valid email address");
    }

    try {
      setLoading(true);
      const response = await fetch(
        "https://api.thewinners2.in/api/v1/notify-Email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: email.trim(),
          }),
        },
      );

      const data = await response.json();

      if (data?.status) {
        toast.success("Mail Sent Successfully!");
        setEmail("");
      } else {
        toast.error(data?.error || "Something went wrong");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="ws-footer_blue">
      {/* <div className="ws-footer-container_blue"> */}

      <div
        className={
          HalfFooterLinks.includes(location.pathname)
            ? "ws-footer-container_blue_new"
            : "ws-footer-container_blue"
        }
      >
        <div className="ws-footer-grid_blue">
          {/* Brand */}
          <div className="ws-footer-brand_blue">
            <img src={logo2} alt="Winners" className="ws-footer-logo_blue" />
            {/* <div className="footer-logo-wrapper">
              <img src={logo2} alt="" className="logo-light ws-footer-logo_blue" />
              <img src={logo3} alt="" className="logo-dark ws-footer-logo_blue" />
            </div> */}

            <p>
              Crafting timeless real estate experiences with trust, innovation
              and transparency. Discover premium properties and future-ready
              investments across India.
            </p>
          </div>

          {/* Links */}
          <div className="ws-footer-col_blue" id="contact-us-section">
            <h4>Useful Links</h4>

            <ul>
              <li>
                <a href="#">About Us</a>
              </li>

              <li>
                <a href="#">Our Portfolio</a>
              </li>

              <li>
                <a href="#">Our Services</a>
              </li>

              <li>
                <a href="#">Contact Us</a>
              </li>
            </ul>
            <div className="ws-footer-social_blue">
              <a href="#">
                <FaFacebookF />
              </a>

              <a href="#">
                <FaInstagram />
              </a>

              <a href="#">
                <FaYoutube />
              </a>

              <a href="#">
                <FaLinkedinIn />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div className="ws-footer-col_blue" id="contact-us-section">
            <h4>Contact Us</h4>

            <ul className="contact-list_blue">
              <li>thewinners2ncr@gmail.com</li>

              <li>+91-8009903561</li>

              <li>
                G-9 Garden
                <br /> East delhi
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="ws-footer-col_blue">
            <h4>Subscribe Now</h4>

            <div className="newsletter-box_blue">
              <input
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                type="email"
                value={email}
                placeholder="Email address"
              />

              <button
                onClick={() => {
                  handleNotify();
                }}
                disabled={loading}
              >
                {/* Sign Up */}
                {loading ? "Loading..." : "Contact Us"}
                <ArrowRight size={16} />
              </button>
            </div>

            <p className="newsletter-text_blue">
              Subscribe to receive updates about new projects, investment
              opportunities and exclusive offers.
            </p>
          </div>
        </div>

        <div className="ws-footer-bottom_blue">
          <span>
            © {new Date().getFullYear()} Winners Realty. All Rights Reserved.
          </span>

          <div className="ws-footer-bottom-links_blue">
            <NavLink
              to="/privacy-policy"
              onClick={() => window.scrollTo(0, 0)}
            >
              Privacy Policy
            </NavLink>

            <span>|</span>

            <NavLink
              to="/terms-and-conditions"
              onClick={() => window.scrollTo(0, 0)}
            >
              Terms of Service
            </NavLink>

            {isLoggedIn && (
              <>
                <span>|</span>

                <NavLink
                  to="/delete-account"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Delete Account
                </NavLink>
              </>
            )}

          </div>
        </div>
      </div>
    </footer>
  );
}
